import { render, staticRenderFns } from "./DialogAddPeticionesMedios.vue?vue&type=template&id=a7e0dd3c&scoped=true"
import script from "./DialogAddPeticionesMedios.vue?vue&type=script&lang=js"
export * from "./DialogAddPeticionesMedios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e0dd3c",
  null
  
)

export default component.exports